import { Add } from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import withDragDropContext from "hocs/withDragDropContext";
import { ArrayPath, FieldArray, FieldValues, useFieldArray, useFormContext } from "react-hook-form";
import FieldsList from "./List";
import { FieldsArrayListProps } from "./types";

const FieldsListWithDragDropContext = withDragDropContext(FieldsList);

const FieldsArrayList = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  fieldName,
  label,
  totalCountLabel,
  valueKeyName = "value",
  addButtonText,
  keyName = "formId",
  renderFieldControlsComponent,
  withDragNDrop = false,
  canRemoveLast,
}: FieldsArrayListProps<TFieldValues>) => {
  const { control } = useFormContext<TFieldValues>();
  const { fields, append, move, update, remove } = useFieldArray({
    control,
    keyName,
    name: fieldName,
  });

  const fieldsListBaseProps = {
    renderFieldControlsComponent,
    disabled,
    keyName,
    fields,
    remove,
    update,
    canRemoveLast,
  };

  return (
    <Box>
      <Stack spacing={2}>
        <Stack
          direction='row'
          spacing={2}
          justifyContent='space-between'
          alignItems='flex-end'>
          <Typography
            variant='body14rg'
            color='text.secondary'>
            {label}
          </Typography>
          <Typography
            variant='body16rg'
            color='primary.main'
            sx={{ py: 1, px: 2, borderRadius: 2, backgroundColor: "bgSwitch" }}>
            {totalCountLabel}: {fields.length}
          </Typography>
        </Stack>
        {withDragNDrop ? (
          // @ts-expect-error проблема типизации из-за хока withDragDropContext
          <FieldsListWithDragDropContext
            droppableId={fieldName}
            moveItems={move}
            withDragNDrop
            {...fieldsListBaseProps}
          />
        ) : (
          <FieldsList {...fieldsListBaseProps} />
        )}
      </Stack>
      <Button
        disabled={disabled}
        startIcon={<Add />}
        sx={({ typography }) => ({
          px: 0,
          justifyContent: "flex-start",
          color: "base.200",
          ...typography.body14rg,
        })}
        onClick={() => append({ [valueKeyName]: "" } as FieldArray<TFieldValues, ArrayPath<TFieldValues>>)}>
        {addButtonText}
      </Button>
    </Box>
  );
};

export default FieldsArrayList;
